import { ThemeInterface, themeNames } from "../theme";
import { colors } from "../../styles/variables";
import { fontWeights, HexColor } from "../../types/styles";

type GatoradeColorNames =
  | "gatoradeOrange"
  | "black"
  | "gatoradeOrangeAdaCompliant";

export const GATORADE_COLORS: Record<GatoradeColorNames, HexColor> = {
  gatoradeOrange: "#FF6E00",
  gatoradeOrangeAdaCompliant: "#CC4B00",
  black: "#000",
};

export const GATORADE_SHARED_HEADING_STYLES = {
  fontWeight: fontWeights["500"],
  color: GATORADE_COLORS.black,
  lineHeight: "1.3",
};

export const GatoradeTheme: ThemeInterface = {
  name: themeNames.Gatorade,
  button: {
    primary: {
      color: GATORADE_COLORS.gatoradeOrange,
      hollowOnHover: true,
    },
    secondary: {
      color: GATORADE_COLORS.gatoradeOrange,
      hollowOnHover: true,
    },
    tertiary: {
      color: GATORADE_COLORS.black,
      hollow: true,
      solidOnHover: true,
    },
    cancel: {
      color: colors.gray600,
      hollow: true,
      solidOnHover: true,
    },
    error: {
      color: colors.red,
      hollow: true,
    },
    text: {
      color: GATORADE_COLORS.gatoradeOrange,
    },
    disabled: {
      hollow: true,
    },
    hasThinBorder: true,
    borderRadius: "100px",
    fontWeight: fontWeights[700],
    padding: "18px 40px",
  },
  color: {
    primary: GATORADE_COLORS.gatoradeOrange,
    secondary: GATORADE_COLORS.black,
    tertiary: colors.white,
    accent: GATORADE_COLORS.gatoradeOrange,
    disabled: colors.gray600,
    action: colors.green,
    error: colors.red,
    text: GATORADE_COLORS.black,
    adaCompliantText: GATORADE_COLORS.gatoradeOrangeAdaCompliant,
  },
  typography: {
    body: {
      color: GATORADE_COLORS.black,
    },
    heading: {
      xxl: {
        fontSize: {
          desktop: "46px",
          mobile: "32px",
        },
        ...GATORADE_SHARED_HEADING_STYLES,
      },
      xl: {
        fontSize: {
          desktop: "32px",
          mobile: "24px",
        },
        ...GATORADE_SHARED_HEADING_STYLES,
      },
      l: {
        fontSize: {
          desktop: "24px",
          mobile: "20px",
        },
        ...GATORADE_SHARED_HEADING_STYLES,
      },
      m: {
        fontSize: {
          desktop: "18px",
          mobile: "18px",
        },
        ...GATORADE_SHARED_HEADING_STYLES,
      },
      s: {
        fontSize: {
          desktop: "16px",
          mobile: "16px",
        },
        ...GATORADE_SHARED_HEADING_STYLES,
      },
      xs: {
        fontSize: {
          desktop: "14px",
          mobile: "14px",
        },
        fontWeight: fontWeights["400"],
        color: GATORADE_COLORS.black,
      },
      xxs: {
        fontSize: {
          desktop: "14px",
          mobile: "14px",
        },
        fontWeight: fontWeights["400"],
        color: GATORADE_COLORS.black,
      },
    },
  },
  borderRadius: "0",
  header: {
    fontSize: "14px",
    // Matches the wordmark size in the gatorade.com header
    logo: {
      width: "122px",
      height: "24.78px",
    },
    portal: {
      backgroundColor: colors.white,
      mobileLinkColor: GATORADE_COLORS.black,
      navLinkColor: GATORADE_COLORS.black,
      navLinkOpacity: "1",
    },
    simple: {
      checkout: {
        backgroundColor: colors.white,
      },
      portal: {
        backgroundColor: colors.white,
      },
    },
  },
  footer: {
    backgroundColor: colors.white,
    textColor: GATORADE_COLORS.black,
    copyright: {
      textColor: GATORADE_COLORS.black,
      backgroundColor: colors.white,
    },
  },
};
